import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import styled from "styled-components";
import Button from "../button/button";

const ModalHeader = styled.h3`
font-size: 16px;
font-weight: 600;
color: black;
`;

const ModalSubHeader = styled.h3`
font-size: 14px;
font-weight: 400;
color: black;
`;

const ModalContainer = styled.div`
width: 400px;
height: auto;
align-items: center;
text-align: center;
`;
const ButtonWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;
export default function AcceptRejectModal(props) {
    return (
        <Modal
            open={props.open}
            onClose={props.onCloseModal}
            classNames="modalContent"
            closeOnEsc={true}
            center={true}
            closeOnOverlayClick={true}
        >
            <ModalContainer>
                <ModalHeader>You're about to {props.action} this offer</ModalHeader>
                <ModalSubHeader>{props.action === "accept" ? (
                    "Please ensure you have reviewed the offer details. Upon acceptance,the company will be notified and may follow up regarding the next steps. Would you like to accept the offer now?")
                    : (
                        "If you are certain, you may proceed with declining. The company will be notified, and you may continue exploring other opportunities on MyNext Talent. Would you like to reject this offer?"
                    )}
                </ModalSubHeader>

                <ButtonWrapper>
                    <Button
                        name={"Yes"}
                        onClick={props.onSubmit}
                    />

                    <Button
                        name={"No"}
                        onClick={props.onCloseModal}
                        secondary
                    />
                </ButtonWrapper>
            </ModalContainer>
        </Modal>
    )
}